import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ALL } from '../../../../../common/constants/app-constants';
import { ITaxonomy } from '../../../../../common/interfaces/iCommonSearchResponse';
import { EventHandler } from '../../../../../common/services/eventHandler';
import { AppSession } from '../../../../../common/values/appSession';
import { BaseComponent } from '../../../../common/components/core/baseCmp';
import { IAffiliationFilter, IProviderAffiliationGroup } from '../../../interfaces/iProviderAffiliation';
import { ProviderDetail } from '../../../services/providerDetail';

@Component({
  moduleId: module.id,
  selector: 'app-fc-affiliation-filter-card-cmp',
  templateUrl: './affiliationFilterCardCmp.html'
})
export class AffiliationFilterCardComponent extends BaseComponent implements OnChanges {
  @Output() closeAndApplyAffiliationFilter: EventEmitter<IAffiliationFilter> = new EventEmitter<IAffiliationFilter>();
  @Output() closeProviderCard: EventEmitter<any> = new EventEmitter<any>();

  @Input() providerAffiliation: Map<string, IProviderAffiliationGroup>;
  @Input() affiliationFilter = {} as IAffiliationFilter;

  affiliationContent = this.content?.result?.affiliationCard;
  defaultFilterValue = ALL;
  filterAffiliation = {} as IAffiliationFilter;

  constructor(
    private _route: ActivatedRoute,
    private _eventHandler: EventHandler,
    @Inject(AppSession)
    private _appSession: AppSession,
    private _providerDetail: ProviderDetail
  ) {
    super(_route, _eventHandler, _appSession);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.filterAffiliation = { ...(this.affiliationFilter || ({} as IAffiliationFilter)) };
    this.filterAffiliation.filterType = this.filterAffiliation.filterType || this.defaultFilterValue;
    this.filterAffiliation.specialtyCode = this.filterAffiliation.specialtyCode || this.defaultFilterValue;
  }

  onFilterTypeChange(data) {
    this.filterAffiliation.filterType = data;
    this.filterAffiliation.specialtyCode = this.defaultFilterValue;
  }
  onSpecialtyChange(data) {
    this.filterAffiliation.specialtyCode = data;
  }

  onCancelFilterCard() {
    this.closeAndApplyAffiliationFilter.emit();
  }

  onCloseProviderCard() {
    this.closeProviderCard.emit();
  }

  onApplyFilter() {
    this.closeAndApplyAffiliationFilter.emit(this.filterAffiliation);
  }

  get specialityFilterOptions(): ITaxonomy[] {
    if (this.filterAffiliation.filterType && this.filterAffiliation.filterType !== this.defaultFilterValue) {
      return this.providerAffiliation?.get(this.filterAffiliation.filterType)?.specialities;
    }
    return [];
  }
}
